import React, { useState, useEffect } from 'react';
import { Select, MenuItem, FormControl, InputLabel, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import axios from 'axios';
import axiosInstance from '../../utils/axiosConfig';

const CallHistory = () => {
  const [agents, setAgents] = useState([]);
  const [selectedAgent, setSelectedAgent] = useState('');
  const [callHistories, setCallHistories] = useState([]);

  useEffect(() => {
    // Fetch all agents
    axiosInstance.get('/agents')
      .then(response => setAgents(response.data))
      .catch(error => console.error('Errore nel recupero degli agenti', error));
  }, []);

  useEffect(() => {
    if (selectedAgent) {
      // Fetch call histories filtered by agent
      axiosInstance.get(`/callHistory?agentId=${selectedAgent.elevenLabsId}`)
        .then(response => {setCallHistories(response.data); console.log(response.data)})
        .catch(error => console.error('Errore nel recupero delle cronologie delle chiamate', error));
    }
  }, [selectedAgent]);

  return (
    <div>
      <FormControl fullWidth>
        <InputLabel>Seleziona Agente</InputLabel>
        <Select
          value={selectedAgent}
          onChange={(e) => setSelectedAgent(e.target.value)}
        >
          {agents.map(agent => (
            <MenuItem key={agent._id} value={agent._id}>
              {agent.name} {/* Assicurati che il modello Agent abbia un campo 'name' */}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Call SID</TableCell>
              {callHistories.length > 0 && Object.keys(callHistories[0].additionalData).map(key => (
                <TableCell key={key}>{key.replace(/_/g, ' ')}</TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {callHistories.map(call => (
              <TableRow key={call._id}>
                <TableCell>{call.callSid}</TableCell>
                {Object.entries(call.additionalData).map(([key, value]) => (
                  <TableCell key={key}>{typeof value === 'boolean' ? (value ? 'Sì' : 'No') : value}</TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default CallHistory;